// TeamData.js

const teamData = [
  {
    name: 'Bhogi Sumasri',
    rollNumber: '20VV1A1208',
    year: '2023-2024',
    role: 'Team Member',
    socials: {
      linkedin: 'https://www.linkedin.com/in/bhogisumasri',
      github: 'https://github.com/bhogisumasri',
      instagram: 'https://instagram.com/bhogisumasri',
      website: 'https://bhogisumasri.com',
      email: 'mailto:bhogisumasri@example.com'
    }
  },
  {
    name: 'Bontalakoti Saikiran',
    rollNumber: '20VV1A1211',
    year: '2023-2024',
    role: 'Team Member',
    socials: {
      linkedin: 'https://www.linkedin.com/in/bontalakotisaikiran',
      github: 'https://github.com/bontalakotisaikiran',
      instagram: 'https://instagram.com/bontalakotisaikiran',
      website: 'https://bontalakotisaikiran.com',
      email: 'mailto:bontalakotisaikiran@example.com'
    }
  },
  {
    name: 'Shaik Vali Basha',
    rollNumber: '20VV1A1257',
    year: '2023-2024',
    role: 'Team Member',
    socials: {
      linkedin: 'https://www.linkedin.com/in/shaikvalibasha',
      github: 'https://github.com/shaikvalibasha',
      instagram: 'https://instagram.com/shaikvalibasha',
      website: 'https://shaikvalibasha.com',
      email: 'mailto:shaikvalibasha@example.com'
    }
  },
  {
    name: 'Uppala Kirtana',
    rollNumber: '20VV1A1261',
    year: '2023-2024',
    role: '',
    socials: {
      linkedin: 'https://www.linkedin.com/in/uppalakirtana',
      github: 'https://github.com/uppalakirtana',
      instagram: 'https://instagram.com/uppalakirtana',
      website: 'https://uppalakirtana.com',
      email: 'mailto:uppalakirtana@example.com'
    }
  }
];

export default teamData;

